import withAddPaytoAccountInitial from 'features/to/HOCs/payment/withAddPaytoAccountInitial';
import withAuthorisePaytoAccount from 'features/to/HOCs/payment/withAuthorisePaytoAccount';
import withPaytoErrorCodeModal from 'features/to/HOCs/payment/withPaytoErrorCodeModal';
import useLang from 'hooks/useLang';
import usePortalModal from 'hooks/usePortalModal';
import { functionUtils } from 'utils';
import Popup from './popup';

const AddPaytoAccountPopup = withAddPaytoAccountInitial(
  withAuthorisePaytoAccount(withPaytoErrorCodeModal(Popup))
);

const AddPaytoAccountModal = ({
  isShow,
  action,
  actionClose,
  modalOptions,
}) => {
  const { t } = useLang();
  const { closePortalModalName } = usePortalModal();

  const handleOnClick = () => {
    if (functionUtils.isFunction(action)) {
      action();
    }
    closePortalModalName();
  };

  const handleOnClose = () => {
    if (functionUtils.isFunction(actionClose)) {
      actionClose();
    }
    closePortalModalName();
  };

  return (
    <>
      <AddPaytoAccountPopup
        isOpen={isShow}
        buttonLabel1={t('button_cancel')}
        onClose={handleOnClose}
        buttonLabel2={t('label_accept_and_continue')}
        onClick={handleOnClick}
        isBackdropOverlap={true}
        zIndexBackdropOverlap={1055}
        modalOptions={modalOptions}
      />
    </>
  );
};

export default AddPaytoAccountModal;
